<template>
  <div class="w-100 h-100 m-0 position-relative" style="padding: 32px; padding-bottom: 0px;">
    <div class="row m-0 p-0 acry-page-title justify-content-center">ACRY PRINT SAMPLE</div>
    <p class="mb-0 pb-0 acry-text-title">実物と同じ色味と仕上がりを事前に確認することができます</p>

    <div class="row m-0 w-100 info-area">
      <div class="d-flex justify-content-center m-0 p-0 w-100">
        <!-- 商品イメージ -->
        <div class="product-img-size position-relative">
          <div class="product-img product-img1" style="margin: 0px 16px" />
          <div class="product-img product-img2" style="margin: 0px 16px" />
          <div class="product-img product-img3" style="margin: 0px 16px" />
        </div>

        <!-- 入稿欄 -->
        <div class="" style="width:330px;">
          <!-- 制作サイズ -->
          <div style="margin:60px 16px 16px 16px;">
            <div class="row m-0 w-100 acry-text-title" style="font-size: 15px;">制作サイズ</div>
            <div class="row m-0 w-100">
              <div
                class="d-flex acry-btn-primary-big draft-btn justify-content-center align-items-center c-pointer" @click="clickDraft(0)">
                <span class="m-4 acry-text-white size-text pe-none">S</span>
                <span class="m-4 pe-none" style="font-size: 13px;">W61×H100(mm)</span>
              </div>
            </div>
            <div class="row m-0 w-100">
              <div
                class="d-flex acry-btn-primary-big draft-btn justify-content-center align-items-center c-pointer" @click="clickDraft(1)">
                <span class="m-4 acry-text-white size-text pe-none">M</span>
                <span class="m-4 pe-none" style="font-size: 13px">W92×H150(mm)</span>
              </div>
            </div>
            <div class="row m-0 w-100">
              <div
                class="d-flex acry-btn-primary-big draft-btn justify-content-center align-items-center c-pointer" @click="clickDraft(2)">
                <span class="m-4 acry-text-white size-text pe-none">L</span>
                <span class="m-4 pe-none" style="font-size: 13px">W139×H225(mm)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column align-items-center" style="background: #F6F5FC; margin: 0px -32px;">
      <img src="@/assets/acrypro/acryprint/acryprint_info1.png" style="width: 600px; padding-top: 40px;">
      <img src="@/assets/acrypro/acryprint/acryprint_info2.png" style="width: 600px;">
      <img src="@/assets/acrypro/acryprint/acryprint_info3.png" style="width: 600px;">
    </div>
  </div>
</template>

<script>
import { CenterViewState, ProductId } from "@/js/Const.js";
// import { ResizeImageBlob, CreateSampleDesignImage } from "@/js/CommonFunc.js";
import { Analytics } from "@/js/Analytics.js";

// import Vue from "vue";
// import config from "config";
import axios from "axios";
// import JSZip from "jszip";
// import VueCookies from "vue-cookies";
// import firebase from "firebase/app";

export default {
  name: "CenterViewPrint_Ap",
  props: {},
  data: function () {
    return {
      shareCode: "",
    };
  },
  computed: {},
  created() {
    // ステートをリセット
    this.$store.commit('acryPrint/reset');

    this.$store.commit("hideRightMenu");

    // this.$store.commit("setDesignImageURL", null);
    // this.$store.commit("setCutlineImageURL", null);
    // this.$store.commit("setScCutlineImageURL", null);
    // this.$store.commit("setFrameCutlineImageURL", null);
    // this.$store.commit("setDesignImageFile", null);
    // this.$store.commit("setCutlineImageFile", null);
    // this.$store.commit("setScCutlineImageFile", null);
    // this.$store.commit("setFrameCutlineImageFile", null);
    // this.$store.commit("setIsShareCodeDraft", false);
    // this.$store.commit("setSelectProductId", "");
    // this.$store.commit("setSelectBackgroundColor", 1);
    // this.$store.commit("setSelectCutlineColor", 2);

    // let isTutorial = VueCookies.get("t_s");
    // if( !isTutorial ){
    //   VueCookies.set("t_s", true, '1y');

    //   // チュートリアル開始
    //   this.$store.commit("showShareCodeTutorial");
    // }
  },
  components: {},
  methods: {
    clickDraft(index) {
      switch (index) {
        case 0:
          Analytics.acryPrintCreateButtonClick('S', true);
          this.$store.commit('acryPrint/set', { key: 'selectProductId', value: ProductId.ACRY_PRINT_S_SAMPLE })
          break;
        case 1:
          Analytics.acryPrintCreateButtonClick('M', true);
          this.$store.commit('acryPrint/set', { key: 'selectProductId', value: ProductId.ACRY_PRINT_M_SAMPLE })
          break;
        case 2:
          Analytics.acryPrintCreateButtonClick('L', true);
          this.$store.commit('acryPrint/set', { key: 'selectProductId', value: ProductId.ACRY_PRINT_L_SAMPLE })
          break;
        default:
          this.$store.commit('acryPrint/set', { key: 'selectProductId', value: 0 })
          break;
      }

      this.$store.commit('designPreview/reset');

      // プリントシートも3Dプレビュー対応
      this.$store.commit('designPreview/set', { key: 'is3DPreviewMode', value: true })

      // プレビュー用のデータを設定
      this.$store.commit('designPreview/set', { key: 'selectProductId', value: this.$store.state.acryPrint.selectProductId })

      // アップロード案内画像は表示する
      this.$store.commit('designPreview/set', { key: 'isShowUploadImage', value: true })

      this.$store.commit("setCenterViewState", CenterViewState.AcryPrintSamplePreview);
    },

    // async clickShareCode() {
    //   if (!this.shareCode) {
    //     return;
    //   }

    //   // シェアコードの小文字を大文字にする
    //   this.$store.commit("showLoading")
    //   const designData = await this.getDesignData(this.shareCode);

    //   if (designData == null || designData.length == 0) {
    //     this.$store.commit("hideLoading");
    //     this.$store.commit("showMessage", "存在しないコードです");
    //     return;
    //   }

    //   // プロダクトIDをチェック
    //   if (
    //     !["FreeAcrylic1", "FreeAcrylic2", "FreeAcrylic3"].includes(designData.productId)
    //   ) {
    //     this.$store.commit("hideLoading");
    //     this.$store.commit("showMessage", "対象外の商品種別");
    //     return;
    //   }

    //   // 有効期限チェック
    //   var expireDate = new Date(designData.expireDate.iso);
    //   var nowDate = new Date();
    //   if( nowDate > expireDate ){
    //     this.$store.commit("hideLoading");
    //     this.$store.commit("showMessage", "有効期限を過ぎています");
    //     return;
    //   }

    //   // デザインデータのダウンロード
    //   const url = config.s3DesignFilePath + designData.file;
    //   const zipData = await this.downloadZipFile(url);
    //   const blob = new Blob([zipData], { type: "application/zip" });
    //   const file = new File([blob], "", {});

    //   const zipdata = await new Promise((resolve) => {
    //     JSZip.loadAsync(file).then((res) => {
    //       resolve(res);
    //     });
    //   });

    //   switch (designData.productId) {
    //     case "FreeAcrylic1":
    //       Analytics.designCodeInput(this.shareCode, 'S', true);
    //       this.$store.commit("setSelectProductId", ProductId.L_SHARE_SAMPLE);
    //       break;
    //     case "FreeAcrylic2":
    //       Analytics.designCodeInput(this.shareCode, 'M', true);
    //       this.$store.commit("setSelectProductId", ProductId.M_SHARE_SAMPLE);
    //       break;
    //     case "FreeAcrylic3":
    //       Analytics.designCodeInput(this.shareCode, 'L', true);
    //       this.$store.commit("setSelectProductId", ProductId.S_SHARE_SAMPLE);
    //       break;
    //   }

    //   // const design_cutlineBlob = await zipdata.file("forcartimage1.png").async("blob");
    //   const designBlob = await zipdata.file("forcartimage2.png").async("blob");
    //   const cutlineBlob = await zipdata.file("forcartimage3.png").async("blob");
    //   // const monoBlob = await zipdata.file("forcartimage4.png").async("blob");

    //   // const design_cutline = new File([design_cutlineBlob], "design_cutine.png", {
    //   //   type: "image/png",
    //   // });
    //   let design = new File([designBlob], "design.png", { type: "image/png" });
    //   let cutline = new File([cutlineBlob], "cutine.png", { type: "image/png" });
    //   // const mono = new File([monoBlob], "mono.png", { type: "image/png" });

    //   // アクリルに合わせるためにリサイズを行う
    //   let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
    //   design = await ResizeImageBlob(design, canvasSize.width, canvasSize.height);
    //   cutline = await ResizeImageBlob(cutline, canvasSize.width, canvasSize.height);

    //   design = await CreateSampleDesignImage(URL.createObjectURL(design), canvasSize.width, canvasSize.height, this.$store.state.selectProductId);

    //   // プレビュー用のデータを設定
    //   this.$store.commit("setCommonDesignImageURL", URL.createObjectURL(design));

    //   // データを保存
    //   this.$store.commit("setDesignImageURL", URL.createObjectURL(design));
    //   this.$store.commit("setScCutlineImageURL", URL.createObjectURL(cutline));
    //   this.$store.commit("setDesignImageFile", design);
    //   this.$store.commit("setScCutlineImageFile", cutline);
    //   this.$store.commit("setIsShareCodeDraft", true);
    //   this.$store.commit("setCenterViewState", CenterViewState.AcryPrintPreview);
    //   this.$store.commit("hideRightMenu");
    //   // this.$store.commit('setRightViewState', RightViewState.SamplePreview);
    // },

    // getDesignData() {
    //   return new Promise((resolve) => {
    //     const ref = firebase.firestore().collection("ShareInfo");
    //     ref.where("key", "==", this.shareCode).get().then((snapshot)=>
    //     {
    //       console.log(snapshot.docs);
    //       const data = snapshot.docs[0].data();
    //       resolve(data)
    //     }).catch(()=>
    //     {
    //       console.log("error");
    //       resolve([]);
    //     });
    //   });
    // },

    async downloadZipFile(url) {
      console.log("download zip :" + url);
      return new Promise((resolve) => {
        axios
          .get(url, {
            responseType: "arraybuffer",
            headers: { Accept: "application/zip" },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            resolve();
          });
      });
    },

    clickShareHelp(){
      this.$store.commit("showShareCodeTutorial");
    },
    endTutorial(){
      this.$store.commit("hideShareCodeTutorial");
    }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.info-area{
  padding: 40px 0px;
  justify-content: center;
  /* border-radius: 15px;
  font-size: 15px;
  border: 0px; */
}
.product-img-size {
  width: 534px;
  height: 356px;
}

@keyframes image-switch-animation {
  /* Hold each image for ~5s and use short fades for cleaner switching */
  0% { opacity: 0; }
  5% { opacity: 1; }
  33% { opacity: 1; }
  38% { opacity: 0; }
  100% { opacity: 0; }
}

.product-img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  border-radius: 20px;
  background-size: cover;
  background-position: center center;
  animation: image-switch-animation 15s infinite;
}

.product-img1 {
  background-image: url("~@/assets/acrypro/acryprint/top_banner1.png");
}
.product-img2 {
  background-image: url("~@/assets/acrypro/acryprint/top_banner2.png");
}
.product-img3 {
  background-image: url("~@/assets/acrypro/acryprint/top_banner3.png");
}

.product-img:nth-of-type(1) { animation-delay: 0s; }
.product-img:nth-of-type(2) { animation-delay: 5s; }
.product-img:nth-of-type(3) { animation-delay: 10s; }

.draft-btn {
  height: 55px;
  width: 100%;
  margin-top: 16px;
}
.dl-btn {
  height: 42px;
  width: 400px;
}
.size-text {
  font-size: 28px;
  font-weight: bold;
}

.acrybtn{
  position: absolute;
  right: 7px;
  top: 5px;
  height: 40px;
  width: 106px;
}
.forminput {
  border-radius: 100px;
  height:50px;
  width: 300px;
  padding-left: 16px;
  border: 0;
  border-bottom: 1px solid $border-sub-color;
  background: $background-purplegray-color;
}
.templateletter{
  letter-spacing: 0.25em;
}
.feature-ui{
  z-index: 5;
  pointer-events: none;
  background: white;
}
</style>
